export const PagePublic = ({ ...props }) => (
  <main
    className={`bg-ui-dark flex h-full w-full place-content-center place-items-center overflow-auto`}
    {...props}
  />
);
